import React, {FC} from 'react';
import ReactSelect, {GroupTypeBase, Props, Styles} from 'react-select';
import styles from './Select.module.scss';

export type Option = {
    value: string | boolean;
    label: string;
};

type SelectProps = {
    isInvalid?: boolean;
    label?: string;
}
type SingleSelectProps = Props<Option, false, GroupTypeBase<Option>> & SelectProps;
type MultiSelectProps = Props<Option, true, GroupTypeBase<Option>> & SelectProps;

const ReactSelectStyles = (hasError: boolean): Partial<Styles<Option, false, GroupTypeBase<Option>>> => ({
    control: (base) => ({
        ...base,
        ...{minHeight: 'none', borderRadius: 4, fontSize: 12},
        ...(hasError ? {border: '2px solid red'} : {border: base.border})
    }),
    dropdownIndicator: base => ({...base, padding: '0 3px', width: 20}),
    input: base => ({...base, lineHeight: '14px'}),
    valueContainer: base => ({...base, padding: '0 8px'}),
    clearIndicator: base => ({...base, padding: '0 3px', width: 20}),
    multiValue: base => ({...base, margin: '0 2px 0 0'}),
    menu: base => ({...base, zIndex: 20, fontSize: 12}),
    menuPortal: base => ({...base, zIndex: 20})
});
const SingleReactSelectStyles = ReactSelectStyles as (hasError: boolean) => Partial<Styles<Option, false, GroupTypeBase<Option>>>;
const MultiReactSelectStyles = ReactSelectStyles as (hasError: boolean) => Partial<Styles<Option, true, GroupTypeBase<Option>>>;

export const Select: FC<SingleSelectProps> = (props) => {
    const {isInvalid, label} = props;
    return (
        <>
            {label && <div className={styles.label}>{label}</div>}
            <ReactSelect
                classNamePrefix={'rs-select2'}
                {...props}
                styles={{...SingleReactSelectStyles(!!isInvalid), ...(props.styles || {})}}
                menuPortalTarget={document.body}
            />
        </>
    );
};

export const MultiSelect: FC<MultiSelectProps> = (props) => {
    const {isInvalid, label} = props;
    return (
        <>
            {label && <div className={styles.label}>{label}</div>}
            <ReactSelect
                isMulti
                classNamePrefix={'rs-select2'}
                {...props}
                styles={{...MultiReactSelectStyles(!!isInvalid), ...(props.styles || {})}}
                menuPortalTarget={document.body}
            />
        </>

    );
};

export function getSelectOptions<T>(data: T[], objLabel: keyof T, objValue: keyof T): Option[] {
    return data.map(el => {
        const label = String(el[objLabel] || 'Empty');
        const value = String(el[objValue]);
        return {label, value};
    });
}